import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDocumentArrowRight32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconDocumentArrowRight32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M22 27a2 2 0 0 0 2-2V13h-8V5h-6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2zm-4-16V5.828L23.172 11zm4 18H10a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4h7.172a2 2 0 0 1 1.414.586l6.828 6.828A2 2 0 0 1 26 11.828V25a4 4 0 0 1-4 4m-5.295-12.86a1 1 0 0 1 1.415 0l3.182 3.182.707.707-.707.707-3.183 3.182a1 1 0 1 1-1.414-1.414L18.21 21H12a1 1 0 1 1 0-2h6.151l-1.446-1.446a1 1 0 0 1 0-1.414"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconDocumentArrowRight32);
